import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

import { useStore } from '@/store/index'
import { getCurrentInstance, reactive, ref, onActivated } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getShopsApi, updateShopStatusAPi, getCheckShopsApi } from '@/apis/shop'
import Keys from '@/constant/key'
import Pagination from '@/components/Pagination.vue'
import {getBrandListApi } from '@/apis/brand'
import { joinParams } from '@/utils/index'


export default /*@__PURE__*/_defineComponent({
  __name: 'ShopList',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const { proxy } = getCurrentInstance() as any
const store = useStore()

const userInfo = store.state.user.userInfo
const brandList = ref([])
const filters = reactive({
    list_type:      1,      // 当前列表类型：0-已上线，1-待上线
    shop_id:        '',     // 门店id
    name:           '',     // 门店名称
    start_date:     '',     // 开始日期
    end_date:       '',     // 结束日期
    brand_id:       '',     // 品牌ID
    status:         '',     // 门店上下架状态
    page:           1,
    page_size:      10,
})
const total = ref(0)

// 标签切换
const onTabChange = (type:number) => {
    filters.list_type = type
    filters.shop_id = ''
    filters.name = ''
    filters.start_date = ''
    filters.end_date = ''
    filters.status = ''
    filters.page = 1
    getTableData()
}

// 获取表格数据
const tableData = ref([])
const getTableData = async () => {
    const {code, data, msg} = filters.list_type==1 ? await getShopsApi(filters) as any : await getCheckShopsApi(filters) as any
    if (code != 200) return proxy.$message({type: 'error', message: msg})
    tableData.value = data.data
    total.value = data.total
}

// 更新状态
const onChangeStatus = (rowData) => {
    const {id, name, status} = rowData
    const message = status==0 ? `确定上架 ${name} 进入审批流吗？` : `确定下架 ${name} 吗？`
    proxy.$confirm(message, '提示', {
        type: 'warning'
    }).then(() => {
        updateShopStatusAPi({id, status: status^1}).then((res:any) => {
            const {code, data, msg} = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            proxy.$message({ type: 'success', message: '保存成功' })
            getTableData()
        })
    }).catch(() => {
        console.log('取消更新状态')
    })
}

// 门店批量上传
const dialogVisible = ref(false)
// 关闭弹框前清空已上传文件列表
const dialogBeforeClose = () => {
    proxy.$refs.upload.clearFiles()
    dialogVisible.value = false
}
// 上传成功后跳转到批量上传列表
const onUploadSuccess = (res) => {
    const {code, data, msg} = res
    if (code != 200) return proxy.$message({ type: 'error', message: msg })

    dialogBeforeClose() // 如不取消弹框，因为 body 加了 el-popup-parent--hidden 会导致下一个页面无法滚动
    router.push(`/merchant-admin/shop-confirm`)
}

const onSearch = () => {
    filters.page = 1
    getTableData()
}
const onPageChange = (val:number) => {
    filters.page = val
    getTableData()
}
const onSizeChange = (val:number) => {
    filters.page_size = val
    getTableData()
}
// 获取品牌列表
const getBrandList = async () => {
    const res = await getBrandListApi({if_body: 2})
    if(res.code == 200) {
        brandList.value = res.data
    } else {
        proxy.$message.error(res.msg || '获取品牌列表失败')
    }
}
const onExport = () => {
    window.open(`${Keys.baseUrl}/sys/admin/importShop?${joinParams({brand_id: filters.brand_id.toString()})}&export_type=1`)
}
// 组件激活时
onActivated(() => {
    if (route.query.brand_id) {
        filters.brand_id = Number(route.query.brand_id)
    }
    getBrandList()
    getTableData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.brand_id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.brand_id) = $event)),
        filterable: "",
        clearable: "",
        placeholder: "品牌名称"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brandList.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.name,
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.shop_id,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.shop_id) = $event)),
        placeholder: "门店id"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.name) = $event)),
        placeholder: "门店名称"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.status) = $event)),
        filterable: "",
        clearable: "",
        placeholder: "门店状态"
      }, {
        default: _withCtx(() => [
          (filters.list_type == 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_option, {
                  label: "下架",
                  value: 0
                }),
                _createVNode(_component_el_option, {
                  label: "上架",
                  value: 1
                })
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_el_option, {
                  label: "未提交",
                  value: -1
                }),
                _createVNode(_component_el_option, {
                  label: "待审核",
                  value: 0
                }),
                _createVNode(_component_el_option, {
                  label: "驳回",
                  value: 2
                })
              ], 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_date,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.start_date) = $event)),
        type: "date",
        placeholder: "更新开始日期",
        "value-format": "YYYY-MM-DD",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_date,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.end_date) = $event)),
        type: "date",
        placeholder: "更新结束日期",
        "value-format": "YYYY-MM-DD",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-item",
        type: "primary",
        onClick: onSearch
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-item",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(router).push('/merchant-admin/shop-edit')))
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [
          _createTextVNode("添加门店")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-item",
        type: "primary",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (dialogVisible.value=true))
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [
          _createTextVNode("批量添加")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-item",
        type: "primary",
        onClick: onExport
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [
          _createTextVNode("导出上架门店")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_row, { class: "tabs" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 2,
          class: _normalizeClass(filters.list_type==1 ? 'active' : ''),
          onClick: _cache[8] || (_cache[8] = ($event: any) => (onTabChange(1)))
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [
            _createTextVNode("已上线")
          ])),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_col, {
          span: 2,
          class: _normalizeClass(filters.list_type==2 ? 'active' : ''),
          onClick: _cache[9] || (_cache[9] = ($event: any) => (onTabChange(2)))
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [
            _createTextVNode("待上线")
          ])),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, {
          prop: "brands_name",
          label: "品牌名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "门店id"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "门店名称",
          width: "150"
        }),
        _createVNode(_component_el_table_column, {
          label: "地址",
          width: "150"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.province + scope.row.city + scope.row.area + scope.row.address), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "phone",
          label: "电话",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          prop: "username",
          label: "门店账号"
        }),
        (filters.list_type==2)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "status_val",
              label: "审核状态"
            }))
          : _createCommentVNode("", true),
        (filters.list_type==1)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "status_val",
              label: "门店状态"
            }))
          : _createCommentVNode("", true),
        (filters.list_type==2)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              prop: "approval_at",
              label: "审核时间"
            }))
          : _createCommentVNode("", true),
        (filters.list_type==2)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 3,
              label: "提交时间"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(scope.row.status > -1 ? scope.row.updated_at : ''), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: filters.list_type==1 ? 185 : 130
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (_unref(router).push(`/merchant-admin/shop-edit?id=${scope.row.id}&t=view&v=${filters.list_type}`))
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (_unref(router).push(`/merchant-admin/shop-edit?id=${scope.row.id}&t=edit&v=${filters.list_type}`)),
                disabled: filters.list_type == 2 && scope.row.status==0
              }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createTextVNode("编辑")
                ])),
                _: 2
              }, 1032, ["onClick", "disabled"]),
              (filters.list_type==1)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (onChangeStatus(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.status==0 ? '上架' : '下架'), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["width"])
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "门店批量添加",
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((dialogVisible).value = $event)),
      "before-close": dialogBeforeClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: dialogBeforeClose }, {
          default: _withCtx(() => _cache[22] || (_cache[22] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: dialogBeforeClose
        }, {
          default: _withCtx(() => _cache[23] || (_cache[23] = [
            _createTextVNode("确 定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "80px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "upload-demo",
                  ref: "upload",
                  action: `/api/admin/shops/importShop?user_id=${_unref(userInfo).id}`,
                  "on-success": onUploadSuccess,
                  accept: ".xls,.xlsx"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                        _createTextVNode("点击上传")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["action"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  href: `${_unref(Keys).baseUrl}/admin/shops/getShopMb?user_id=${_unref(userInfo).id}`,
                  type: "primary"
                }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createTextVNode("下载批量添加模版")
                  ])),
                  _: 1
                }, 8, ["href"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})